exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../../styles/typography.css"), undefined);

// module
exports.push([module.id, ".RangeSelect--container--wOEXa{display:flex;flex-direction:row;padding-top:15px}", ""]);

// exports
exports.locals = {
	"container": "RangeSelect--container--wOEXa " + require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../../styles/typography.css").locals["mediumContrastText"] + " " + require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../../styles/typography.css").locals["defaultSize"] + ""
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/components/trends/cbg/RangeSelect.css
 ** module id = 57
 ** module chunks = 0
 **/